module.exports = __webpack_public_path__ + "static/media/20240419090156_IMG_6524 (1)_Crop Image-min.755dd628.jpg";